import { render, staticRenderFns } from "./SearchTabsTheme1.vue?vue&type=template&id=7636bbbf&scoped=true"
import script from "./SearchTabsTheme1.vue?vue&type=script&lang=js"
export * from "./SearchTabsTheme1.vue?vue&type=script&lang=js"
import style0 from "./SearchTabsTheme1.vue?vue&type=style&index=0&id=7636bbbf&prod&scoped=true&lang=css"
import style1 from "./SearchTabsTheme1.vue?vue&type=style&index=1&id=7636bbbf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7636bbbf",
  null
  
)

export default component.exports